export default __webpack_public_path__ + "static/media/banners_cybermonday_coche_330x330.2a37b0ec.jpg";